import React, {Component} from 'react'
import 'antd/lib/date-picker/style/index.css'
import PropTypes from 'prop-types'
import {DatePicker} from 'antd'
import moment from 'moment'

const {RangePicker} = DatePicker

class FilterDateReport extends Component {
    timeout = 0

    _handleDateChange = async (date, dateString) => {
        const [from, to] = dateString
        const {onChangeFilters} = this.props

        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        if (typeof onChangeFilters === 'function') {
            const filters = Object.assign({}, this.props.filters)

            filters.created = {
                from,
                to
            }

            if (!to && !from) {
                delete filters.created
            }

            await onChangeFilters(filters)
        }
    }

    render() {
        const {filters} = this.props
        const {created} = filters

        return (
            <div className="FilterShippedAt mb-3 mr-3">
                <label className='font-weight-bold d-block'>Ngày yêu cầu</label>
                <RangePicker
                    placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                    value={[created !== undefined ? moment(created.from, 'DD/MM/YYYY') : '', created !== undefined ? moment(created.to, 'DD/MM/YYYY') : '']}
                    ranges={{
                        'Today': [moment(), moment()],
                        'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                    }}
                    format={'DD/MM/YYYY'}
                    onChange={this._handleDateChange}
                />
            </div>
        )
    }
}

FilterDateReport.propTypes = {
    filters: PropTypes.object.isRequired,
    onChangeFilters: PropTypes.func.isRequired,
}

export default FilterDateReport